import React, { useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import SEO from '../component/SEO';
import {  formatTimeAgo, getReadTime } from '../utils/Universalfunctions';
import Loading from '../component/Loading';
import { Instagram } from '@mui/icons-material';
import ImageGenerateAds from '../Ads/ImageGenerateAds';
import { ideasBatch } from './data';

const AdminInterestedDetail = () => {
     const { id } = useParams();
     const [problemData, setProblemData] = useState(null);
     const [loading, setLoading] = useState(true);
     const [errorText, setErrorText] = useState('');

     useEffect(() => {
          const fetchProblemDetail = () => {
               setLoading(true);
               setErrorText('');

               const localData = ideasBatch.find(p => p.id === id);

               if (localData) {
                    setProblemData(localData);
               } else {
                    setErrorText('Problem not found.');
               }
               setLoading(false);
          };

          if (id) {
               fetchProblemDetail();
          }
     }, [id]);

     if (loading) {
          return (
               <div className="immersive-detail text-center">
                    <Loading text="Loading..." />
               </div>
          );
     }

     if (errorText || !problemData) {
          return (
               <div className="immersive-detail text-center">
                    <Loading text={errorText || 'Problem not found.'} />
               </div>
          );
     }

     const {
          category,
          problem,
          userName,
          createdAt,
          content,
          type,
          title,
     } = problemData;

     return (
          <>
               <SEO
                    title={problemData?.problem || "Idea Details"}
                    description={problemData?.problem?.slice(0, 150)}
               />

               <div className="immersive-detail">
                    <div className="story-container">
                         <div className="story-header">
                              <div className="meta-strip">
                                   <Link className='pill' to="/"> Home </Link>
                                   <span className="pill">
                                        Date / 2026
                                   </span>
                              </div>

                              <div className="author-row">
                                   <img src={`https://ui-avatars.com/api/?name=${encodeURIComponent(userName || 'U')}&background=111827&color=fff`} alt={userName || 'User'} />
                                   <div className="author-meta">
                                        <strong>{userName || 'Unknown User'}</strong>
                                        <span>{formatTimeAgo(createdAt)} </span>
                                   </div>
                              </div>
                         </div>

                         <section className="metrics-bar">
                              <div className="metric">
                                   <label>type</label>
                                   <strong className={`high ${type === 'Problem' ? 'text-danger' : 'text-success'}`}>{type}</strong>
                              </div>

                              <div className="metric">
                                   <label>Priority</label>
                                   <strong>{category}</strong>
                              </div>

                              <div className="metric">
                                   <label>Read Time</label>
                                   <strong>{getReadTime(problem)}</strong>
                              </div>
                         </section>

                         <article className="story-content">
                              <section className="content-block">

                                   <h3>{title}</h3>
                                   <p>{problem}</p>

                                   <div style={{ margin: '40px 0' }}>
                                        <ImageGenerateAds />
                                   </div>

                                   <div
                                        dangerouslySetInnerHTML={{ __html: content }}
                                   />

                                   {problemData?.instagram && (
                                        <Link
                                             to={`https://www.instagram.com/${problemData.instagram}`}
                                             target="_blank"
                                             rel="noopener noreferrer"
                                             className="insta-link">
                                             <span className="icon">
                                                  <Instagram />
                                             </span>
                                             <span className="label">Instagram</span>
                                        </Link>
                                   )}
                              </section>

                              <div className="section-divider">
                                   <div className="line"></div>
                                   <div className="triangle"></div>
                                   <div className="triangle"></div>
                                   <div className="line"></div>
                              </div>

                              <section className="content-block">
                                   <h3>Admin Insight</h3>
                                   <p>This entry was submitted as a potential startup concept or workflow improvement. It is currently stored for internal review and execution planning.</p>
                                   <p>As an admin, you can analyze the <strong>{category}</strong> priority and use the provided <strong>{type}</strong> details to draft a newsletter or plan a prototype.</p>
                                   <p>Use the edit action to refine the technical content or update the problem-solution fit based on new research.</p>
                              </section>
                         </article>

                    </div>

               </div>
          </>
     );
};

export default AdminInterestedDetail;